import React, { Component } from 'react'
import { Modal, Row, Col, Form } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { defaultBranchValue } from "../../../../utils/branchScope";
import "./_materialCreation.scss";


const CREATE_MATERIALS = gql`
  mutation($params: CreateMaterials) {
    createMaterials(params: $params)
  }
`;

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_MATERIALS = gql`
  query($institute_id:Int,$branch_id:Int,$class_id:Int,$material_type_id:Int){
    getMaterials(institute_id:$institute_id,branch_id:$branch_id,class_id:$class_id,material_type_id:$material_type_id){
      id
      material_name
    }
  }
`;

const FIN = {
    label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
    input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    section: { background: "#fff", borderRadius: 12, padding: "20px 20px 8px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "11px 34px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
    btnAddRow: { display: "inline-flex", alignItems: "center", gap: 6, background: "#f5f3ff", color: "#7c3aed", border: "1px solid #ddd6fe", borderRadius: 9, padding: "8px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
};

class MaterialCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: defaultBranchValue(""),
            branchError: "",
            class: "",
            classError: "",
            materialtypes: "",
            materialtypesError: "",
            getClasses: [],
            materialTypesData: props.getMaterialTypes,
            getBranchesData: [],
            allClasses: [],
            dataClear: 1,
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            materialsData: [],
            is_grouping: true,
            defaultvalue: 0
        };
    }

    async componentDidMount() {
        try {
            const [branchesRes, classesRes] = await Promise.all([
                this.props.client.query({ query: GET_BRANCHES, variables: { institution_id: parseInt(Cookies.get("institutionid")) }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_CLASSES, variables: { id: 1 }, fetchPolicy: "network-only" }),
            ]);
            let branches = branchesRes.data.getBranches || [];
            if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                const branchId = Cookies.get("branch_id");
                branches = branches.filter(b => String(b.id) === String(branchId));
            }
            this.setState({ getBranchesData: branches, allClasses: classesRes.data.getExamClasses || [] });
        } catch (err) {
            console.error("material creation load error", err);
        }
    }

    classOptionsForBranch = (branchId) => {
        const b = (this.state.getBranchesData || []).find(x => String(x.id) === String(branchId));
        const sections = b ? (b.sections || []) : [];
        const classIds = [...new Set(sections.map(s => Number(s.class_id)))];
        return classIds
            .map(cid => (this.state.allClasses || []).find(c => c.id === cid))
            .filter(Boolean)
            .map(c => ({ value: c.id, label: c.class }));
    };

    addRow = () => {
        const array = this.state.materialsData;
        array.push({ id: null, material_name: "" });
        this.setState({ materialsData: array });
    }

    handleChange = (e, i) => {
        const value = e.target.value;
        const array1 = [];
        this.state.materialsData.map((item, index) => {
            if (index == i) {
                array1.push({ ...item, material_name: value, materialNameError: "" });
            } else {
                array1.push({ ...item });
            }
        });
        this.setState({ materialsData: array1 });
    }

    deleteHandle = (i) => {
        const updatedRows = this.state.materialsData.filter((item, index) => index != i);
        this.setState({ materialsData: updatedRows });
    }

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "materialtypes") {
            if (value != "0") {
                const grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1 ? true : false;
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    getClasses: [], materialsData: [], materialtypesError: "",
                    materialtypes: value, is_grouping: grouping
                });
            } else {
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    getClasses: [], materialsData: [], materialtypesError: "",
                    materialtypes: 0, is_grouping: true
                });
            }
        }

        if (name == "branch") {
            if (value != "0") {
                this.setState({
                    branch: value, branchError: "", class: "", classError: "",
                    getClasses: this.classOptionsForBranch(value), materialsData: [], materialtypesError: ""
                });
                if (!this.state.is_grouping) {
                    this.getMaterials(value, "");
                }
            } else {
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    getClasses: [], materialsData: []
                });
            }
        }

        if (name == "class") {
            if (value != "0") {
                this.setState({ class: value, classError: "", materialsData: [] });
                this.getMaterials(this.state.branch, value);
            } else {
                this.setState({ class: "", classError: "", materialsData: [] });
            }
        }
    }

    getMaterials = async (branchId, classId) => {
        const result = await this.props.client.query({
            query: GET_MATERIALS,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(branchId),
                class_id: parseInt(classId),
                material_type_id: parseInt(this.state.materialtypes)
            },
            fetchPolicy: 'network-only'
        });
        if (result.data.getMaterials.length > 0) {
            this.setState({ materialsData: result.data.getMaterials });
        } else {
            this.setState({ materialsData: [{ id: null, material_name: "" }] });
        }
    }

    handleSubmit = () => {
        if (this.state.materialtypes == "" || this.state.materialtypes == "0") {
            this.setState({ materialtypesError: "Please Select Material" }); return;
        }
        if (this.state.branch == "" || this.state.branch == "0") {
            this.setState({ branchError: "Please Select Branch" }); return;
        }
        if (this.state.is_grouping && (this.state.class == "" || this.state.class == "0")) {
            this.setState({ classError: "Please Select Class" }); return;
        }

        let stopExecuting = false;
        this.state.materialsData.some((obj, i) => {
            const errorUpdate = this.state.materialsData;
            if (obj.material_name == "" || obj.material_name == undefined) {
                errorUpdate[i] = { ...obj, materialNameError: "Please Type" };
                this.setState({ materialsData: errorUpdate });
                stopExecuting = true;
                return true;
            }
        });
        if (stopExecuting) return;

        const array = [];
        if (this.state.materialsData.length > 0) {
            this.state.materialsData.map((item) => {
                array.push({ id: item.id, material_name: item.material_name });
            });
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            class_id: parseInt(this.state.class),
            material_type_id: parseInt(this.state.materialtypes),
            materialDetails: array
        };

        this.setState({ loadingSpinner: 1 });
        this.createMaterials(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
        });
    }

    createMaterials = async (params) => {
        await this.props.createMaterials({
            variables: { params },
            update: (store, { data }) => {
                if (data.createMaterials) {
                    this.setState({ loadingSpinner: 0, currentStep: 5 });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        });
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "", branchError: "", class: "", classError: "",
                materialtypes: "", materialtypesError: "",
                getClasses: [], materialTypesData: this.props.getMaterialTypes,
                dataClear: 1, loadingSpinner: 0, currentStep: 1, submitError: "",
                materialsData: [], is_grouping: true
            });
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 });
        }
    }

    render() {
        return (
            <Modal {...this.props} size="lg" aria-labelledby="material-creation-modal">
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 9 }}>
                        <i className="fal fa-layer-group" style={{ color: "#7c3aed" }} />Material Creation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#F8FAFC", padding: "24px 24px 16px" }}>
                    <div style={FIN.section}>
                        <p style={FIN.heading}><i className="fal fa-filter" />Material Details</p>
                        <Row>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <label style={FIN.label}>Material Type</label>
                                <select style={FIN.input} name="materialtypes" onChange={this.handleInputChange} value={this.state.materialtypes}>
                                    <option value="0">--Select Material--</option>
                                    {this.state.materialTypesData.map((item1) => (
                                        <option key={item1.id} value={item1.id}>{item1.material_type}</option>
                                    ))}
                                </select>
                                {this.state.materialtypesError ? <span style={FIN.err}>{this.state.materialtypesError}</span> : null}
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <label style={FIN.label}>Branch</label>
                                <select style={FIN.input} name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                    <option value="0">--Select Branch--</option>
                                    {this.state.getBranchesData.map((b) => (
                                        <option key={b.id} value={b.id}>{b.branch_name}</option>
                                    ))}
                                </select>
                                {this.state.branchError ? <span style={FIN.err}>{this.state.branchError}</span> : null}
                            </Col>
                            {this.state.is_grouping ? (
                                <Col lg={4} md={6} sm={12} className="mb-3">
                                    <label style={FIN.label}>Class</label>
                                    <select style={FIN.input} name="class" onChange={this.handleInputChange} value={this.state.class}>
                                        <option value="0">--Select Class--</option>
                                        {this.state.getClasses.map((c) => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </select>
                                    {this.state.classError ? <span style={FIN.err}>{this.state.classError}</span> : null}
                                </Col>
                            ) : null}
                        </Row>
                    </div>

                    {this.state.materialsData.length > 0 ? (
                        <div style={FIN.section}>
                            <p style={FIN.heading}><i className="fal fa-list" />Materials</p>
                            <Row>
                                {this.state.materialsData.map((item1, i) => (
                                    <Col lg={6} md={6} sm={12} key={i} className="mb-3">
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <input type="text" style={FIN.input} placeholder="Type material name..." onChange={(e) => this.handleChange(e, i)} value={item1.material_name} name="materialName" />
                                            {this.state.materialsData.length > 1 ? (
                                                <button type="button" onClick={() => this.deleteHandle(i)} style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 9, width: 42, height: 44, flexShrink: 0, cursor: "pointer" }}>
                                                    <i className="far fa-trash-alt" />
                                                </button>
                                            ) : null}
                                        </div>
                                        {item1.materialNameError ? <span style={FIN.err}>{item1.materialNameError}</span> : null}
                                    </Col>
                                ))}
                            </Row>
                            {this.state.is_grouping ? (
                                <button type="button" onClick={this.addRow} style={FIN.btnAddRow}>
                                    <i className="fas fa-plus" /> Add Material
                                </button>
                            ) : null}
                        </div>
                    ) : null}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: "none", justifyContent: "center", flexDirection: "column" }}>
                    {this.state.currentStep == 5 ? (
                        <p style={{ color: "#059669", fontWeight: 600, marginBottom: 10 }}>Material Created Successfully</p>
                    ) : this.state.submitError ? (
                        <p style={{ color: "#dc2626", marginBottom: 10 }}>{this.state.submitError}</p>
                    ) : null}
                    <button type="button" style={FIN.btnPrimary} onClick={() => this.handleSubmit()}>
                        {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-plus-circle" />}
                        Create Material
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(CREATE_MATERIALS, {
        name: "createMaterials"
    }),
)(MaterialCreationModal))
);
